import events from '../events/events';

const University = {};

/**
 * University plugin
 *
 * @param Vue
 * @param options
 */
University.install = function(Vue, options)
{
    let methods =
    {
        lessons: [],
        history: [],

        open()
        {
            events.$emit('university.open');
        },

        close()
        {
            events.$emit('university.close');
        },

        toggle()
        {
            events.$emit('university.toggle');
        },

        lesson(lesson, callback)
        {
            this.history.push(lesson.id);

            events.$emit('lesson.open', lesson, callback);
        },
    };

    // register global methods
    Vue.university = methods;

    // register instance methods
    Vue.prototype.$university = methods;
};

export default University;



// WEBPACK FOOTER //
// ./src/js/plugins/university.js